import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M3.416 9.082v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 1.5 0Zm2.81-3.23a.75.75 0 0 0-.75.75v6.73a.75.75 0 1 0 1.5 0V6.6a.755.755 0 0 0-.75-.748Zm7.11-3.93a.743.743 0 0 0-.75.75v10.66a.75.75 0 0 0 1.5 0V2.672a.748.748 0 0 0-.75-.75Zm-3.56 5.06a.75.75 0 0 0-.75.75v5.6a.75.75 0 0 0 1.5 0v-5.6a.743.743 0 0 0-.75-.75Z';
const draw24px = 'M4,21.75A.75.75,0,0,1,3.25,21V13.82a.75.75,0,0,1,1.5,0V21A.75.75,0,0,1,4,21.75ZM10.07,21V9.63a.75.75,0,0,0-1.5,0V21a.75.75,0,0,0,1.5,0Zm5.32,0V11.53a.75.75,0,0,0-1.5,0V21a.75.75,0,0,0,1.5,0Zm5.36,0V3a.75.75,0,1,0-1.5,0V21a.75.75,0,0,0,1.5,0Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ChartBarIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'chartBar'));
ChartBarIcon.displayName = 'ChartBarIcon';
ChartBarIcon.propTypes = Icon.propTypes;
ChartBarIcon.renderIcon = props => /*#__PURE__*/React.createElement(ChartBarIcon, props);
export default ChartBarIcon;
//# sourceMappingURL=ChartBarIcon.js.map